import { Grid } from "@mui/material";
import { HeaderData } from "./components/HeaderData";
import { AdditionsTable } from "./components/tables/additions-table/AdditionsTable";
import { ChargesTable } from "./components/tables/charges-table/ChargesTable";
import { DelaysTable } from "./components/tables/delays-table/DelaysTable";
import { HeatingsTable } from "./components/tables/heatings-table/HeatingsTable";
import { ProbesTable } from "./components/tables/probes-table/ProbesTable";
import { PhasesTable } from "./components/tables/phases-table/PhasesTable";
import { InjectionsTable } from "./components/tables/injections-table.tsx/InjectionsTable";

export const EAFProcessData = () => {
  return (
    <>
      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12}>
          <HeaderData />
        </Grid>
      </Grid>

      <Grid item xs={12} container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={4}>
          <ProbesTable />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <PhasesTable />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <ChargesTable />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <AdditionsTable />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <HeatingsTable />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <InjectionsTable />
        </Grid>
      </Grid>
      <Grid item xs={12} container spacing={2}>
        <Grid item xs={12}>
          <DelaysTable />
        </Grid>
      </Grid>
    </>
  );
};
